<template>
  <div style="padding-bottom: 10px">
    <big-one :content="content" :type = "type" :objects="objects"></big-one>
  </div>
</template>
<script>

const tsrBaseTsrName = {header: "Наименование", name: "basis.name", show: true};
const tsrNextDate = {header: "Следующая дата", name: "nextDate", show: true};
const tsrCostPrice = {header: "Стоимость", name: "costPrice", show: true}
const tsrCompensation = {header: "Компенсация", name: "compensation", show: true}

export default{
  props:{
    clientId: null
  },
  data() {
    return {
      type: "tsr",
      content: [tsrBaseTsrName, tsrNextDate, tsrCostPrice, tsrCompensation],
      objects: []
    }
  },
  methods: {
  },
  async mounted() {
     this.objects = await this.$repo.getByURL('tsr/client/' + this.clientId);
  }
}
</script>
<style>
</style>
